import { render } from "./PartialErrorPage.vue?vue&type=template&id=98f50732&scoped=true"
import script from "./PartialErrorPage.vue?vue&type=script&lang=js"
export * from "./PartialErrorPage.vue?vue&type=script&lang=js"

import "./PartialErrorPage.vue?vue&type=style&index=0&id=98f50732&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98f50732"]])

export default __exports__